// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const DOCUMENT_BASE_URL = '/api/v1/wechat/document';

/**
 * 获取发文审批流程列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getDocumentApplicationList(
  params?: OA.DocumentApplicationListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DocumentApplicationListData>>(
    `${DOCUMENT_BASE_URL}/applications`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 获取发文审批详情
 * @param sp_no 审批单号
 * @param options 请求配置
 */
export async function getDocumentApplicationDetail(
  sp_no: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.ApprovalDetail>>(
    `${DOCUMENT_BASE_URL}/detail/${sp_no}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 配置发文号起始序号
 * @param data 配置参数
 * @param options 请求配置
 */
export async function setDocumentNumberConfig(
  data: OA.SetDocumentNumberConfigParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DocumentNumberConfig>>(
    `${DOCUMENT_BASE_URL}/number-config`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 获取发文号配置
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getDocumentNumberConfig(
  params: OA.GetDocumentNumberConfigParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DocumentNumberConfig>>(
    `${DOCUMENT_BASE_URL}/number-config`,
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}

/**
 * 获取发文号配置列表
 * @param options 请求配置
 */
export async function getDocumentNumberConfigs(
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DocumentNumberConfig[]>>(
    `${DOCUMENT_BASE_URL}/number-configs`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 获取发文统计信息
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getDocumentStatistics(
  params?: OA.GetDocumentStatisticsParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DocumentStatistics[]>>(
    `${DOCUMENT_BASE_URL}/statistics`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 导出发文（使用模板）
 * @param sp_no 审批单号
 * @param use_template 是否使用红头文件模板
 * @param options 请求配置
 */
export async function exportDocument(
  sp_no: string,
  use_template: boolean = true,
  options?: { [key: string]: any },
) {
  return request<Blob>(
    `${DOCUMENT_BASE_URL}/export/${sp_no}`,
    {
      method: 'GET',
      params: { use_template },
      responseType: 'blob',
      ...(options || {}),
    },
  );
}

/**
 * 导出发文单
 * @param sp_no 审批单号
 * @param options 请求配置
 */
export async function exportDocumentForm(
  sp_no: string,
  options?: { [key: string]: any },
) {
  return request<Blob>(
    `${DOCUMENT_BASE_URL}/export-form/${sp_no}`,
    {
      method: 'GET',
      responseType: 'blob',
      ...(options || {}),
    },
  );
}

/**
 * 发起发文传阅
 * @param sp_no 审批单号
 * @param data 传阅参数
 * @param options 请求配置
 */
export async function circulateDocument(
  sp_no: string,
  data: OA.CirculateDocumentParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.CirculateDocumentResponse>>(
    `${DOCUMENT_BASE_URL}/circulate/${sp_no}`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 获取发文传阅记录
 * @param sp_no 审批单号
 * @param options 请求配置
 */
export async function getDocumentCirculations(
  sp_no: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DocumentCirculationRecord[]>>(
    `${DOCUMENT_BASE_URL}/circulations/${sp_no}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 获取发文传阅文件列表
 * @param sp_no 审批单号
 * @param options 请求配置
 */
export async function getDocumentFiles(
  sp_no: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DocumentFilesResponse>>(
    `${DOCUMENT_BASE_URL}/files/${sp_no}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 更新发文传阅文件列表（全量替换）
 * @param sp_no 审批单号
 * @param data 文件信息列表
 * @param options 请求配置
 */
export async function updateDocumentFiles(
  sp_no: string,
  data: OA.UpdateDocumentFilesParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.DocumentFilesResponse>>(
    `${DOCUMENT_BASE_URL}/files/${sp_no}`,
    {
      method: 'PUT',
      data,
      ...(options || {}),
    },
  );
}
